// nameRule.js — the Name Change's one rule, pure (no Firebase), so tools/name-check.mjs can prove it.
export const NAME_MAX = 24;          // = ieSocial NAME_MAX — a LAW (rules.json caps every stored name)

/** Pure: a typed name → the name that would be stored, or an error (tested by tools/name-check.mjs). */
export function cleanNewName(raw, current) {
  const name = String(raw || "").replace(/\p{Cc}/gu, " ").replace(/\s+/g, " ").trim().slice(0, NAME_MAX);
  if (!name) return { ok: false, message: "Write the new name first." };
  if (name.length < 2) return { ok: false, message: "Two letters at least." };
  if (current && name === String(current).trim()) return { ok: false, message: "That's already your name." };
  return { ok: true, name };
}

